import { resumeProfile } from '../pdf/resumeContent';
import { ensurePdfPolyfills } from './pdfPolyfills';

export async function downloadResumePdf(): Promise<void> {
  await ensurePdfPolyfills();

  const baseUrl = window.location.origin;

  const [{ pdf }, { ResumeDocument }] = await Promise.all([
    import('@react-pdf/renderer'),
    import('../pdf/ResumeDocument'),
  ]);

  const blob = await pdf(<ResumeDocument baseUrl={baseUrl} />).toBlob();

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${resumeProfile.name.replace(/\s+/g, '-')}-resume.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
